// web/client/src/app-top.tsx
import React from "react";
import logoMed from "./images/logo/logo-med64.gif";
import RoomCode from "./components/common/room-code/room-code";
import AudienceLabel from "./components/common/audience-label/audience-label";

type Props = {
  extraLabel?: string;
  roomCode?: string;
};

const AppTop: React.FunctionComponent<Props> = React.memo((props) => {
  return (
    <div className="mx-0 flex flex-row justify-between md:mx-4">
      <div className="z-20">
        <img
          className="h-8 w-auto bg-night-primary border-black border-[3px] border-b-0 md:mt-2 md:h-16 md:shadow-aestheticTop md:px-1"
          src={logoMed}
          alt="Frantic Fanfic Logo"
        />
      </div>
      <div className="self-end flex flex-row justify-end space-x-1">
        {props.extraLabel && <AudienceLabel />}
        {props.roomCode && <RoomCode />}
      </div>
    </div>
  );
});

export default AppTop;
